import axios from 'axios';
import BaseAPI from './base/base-api';

class ConnecInvoiceAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'InvoiceBotsAPI';
    controllerName = 'connectInvoice';
}

export default new ConnecInvoiceAPI();